// Sales Issues reducer helper functions and data
import { Order } from "types/orders.types";
import { Pagination } from "types/common.types";
import { OrdersState } from "./issues.types";
import { ViewTypes } from "types/issues.types";
import { getInitialPaginationData } from "util/pagination";

export const orderPagination: Pagination<Order> = {
  page: 0,
  totalPages: 1,
  items: {}
};

export const resetSalesIssuesState: OrdersState = {
  selectedModuleId: "",
  orderBy: "",
  selectedBoxId: "",
  issuesByCustomer: getInitialPaginationData(),
  viewType: ViewTypes.ROWS
};
